import React, {useState} from "react";

export default function ResetPopup(props) {


    return (
        <div className="grid-x align-center">
            <div className="cell text-center">
                <h3 className='text-center mar-bot-10'>Test has been successfully reset!</h3>
                <p className='popup__text'>
                    The user is now able to retake the {props.name} test. {props.retakes === 'unlimited' ? null : `You have ${props.retakes}  ${props.retakes === 1 ? 'reset' : 'resets'} remaining for this test.`}
                </p>
            </div>
        </div>
    )

}